import Vue from 'vue'
import Router from 'vue-router'
import page from './page/index.vue'
import login from './login/login.vue'
import main from './main/'
import workbench from './workbench/index.vue'
import UserList from './Admins/User/List'
import AddressList from './Admins/Address/List'
import DictionaryList from './Admins/Dictionary/List'
import DealerGroupList from './Basic/DealerGroup/List'
import BannerList from './Basic/Banner/List'
import BannerAdd from './Basic/Banner/Add'
import RoleList from './Admins/Role/List'
import ExportTaskList from './Reports/ExportTask/List'
import AnnouncementList from './Information/Announcement/List'
import EmployeeList from './Basic/Employee/List'
import OrganizationList from './Basic/Organization/List'
import DealerList from './Basic/Dealer/List'
import FeedbackList from './Information/Feedback/List'
import ProductCategoryList from './Goods/ProductCategory/List'
import ProductList from './Goods/Product/List'
import SalesPriceList from './Goods/SalesPrice/List'
import ActivityList from './Promotions/Activity/List'
import CreditList from './Basic/Credit/List'
import OrderRuleList from './Orders/OrderRule/List'
import OrderList from './Orders/OrderMaster/List'
import OrderAuditList from './Orders/OrderMaster/AuditList'
import BomProductList from './Goods/BomProduct/List'
import wait from './wait/'
import SalesPriceHistoryList from './Goods/SalesPriceHistory/List'
import DeliveryOrderList from './Orders/DeliveryOrder/List'
import OrderExportList from './Reports/OrderExport/List'
import ProductUnionList from './Goods/ProductUnion/List'
import DriverList from './Admins/Driver/List'
import FreightList from './Goods/Freight/List'
import FreightRecordList from './Goods/Freight/Record'

Vue.use(Router)
const pages = {
  index: [{
    path: '/index',
    name: 'index',
    component: workbench,
    meta: {
      name: '工作台'
    }
  }],
  Admins: [{
    path: '/Admins/User/List',
    name: '/Admins/User/List',
    component: page,
    redirect: {
      name: '/Admins/User/List/list'
    },
    meta: {
      name: '账号管理'
    },
    children: [{
      path: '/Admins/User/List/list',
      name: '/Admins/User/List/list',
      component: UserList,
      meta: {
        name: '账号管理',
        parent: '/Admins/User/List'
      }
    }]
  },
  {
    path: '/Admins/Dictionary/List',
    name: '/Admins/Dictionary/List',
    component: page,
    redirect: {
      name: '/Admins/Dictionary/List/list'
    },
    meta: {
      name: '字典管理'
    },
    children: [{
      path: '/Admins/Dictionary/List/list',
      name: '/Admins/Dictionary/List/list',
      component: DictionaryList,
      meta: {
        name: '字典管理',
        parent: '/Admins/Dictionary/List'
      }
    }]
  },
  {
    path: '/Basics/Banner/List',
    name: '/Basics/Banner/List',
    component: page,
    redirect: {
      name: '/Basics/Banner/List/list'
    },
    meta: {
      name: 'Banner管理'
    },
    children: [{
      path: '/Basics/Banner/List/list',
      name: '/Basics/Banner/List/list',
      component: wait,
      meta: {
        name: 'Banner管理',
        parent: '/Basics/Banner/List'
      }
    }]
  },
  {
    path: '/Basic/DealerGroup/List',
    name: '/Basic/DealerGroup/List',
    component: page,
    redirect: {
      name: '/Basic/DealerGroup/List/list'
    },
    meta: {
      name: '经销商分组'
    },
    children: [{
      path: '/Basic/DealerGroup/List/list',
      name: '/Basic/DealerGroup/List/list',
      component: DealerGroupList,
      meta: {
        name: '经销商分组',
        parent: '/Basic/DealerGroup/List'
      }
    }]
  },
  {
    path: '/Basic/Employee/List',
    name: '/Basic/Employee/List',
    component: page,
    redirect: {
      name: '/Basic/Employee/List/list'
    },
    meta: {
      name: '员工管理'
    },
    children: [{
      path: '/Basic/Employee/List/list',
      name: '/Basic/Employee/List/list',
      component: EmployeeList,
      meta: {
        name: '员工管理',
        parent: '/Basic/Employee/List'
      }
    }]
  },
  {
    path: '/Basic/Dealer/List',
    name: '/Basic/Dealer/List',
    component: page,
    redirect: {
      name: '/Basic/Dealer/List/list'
    },
    meta: {
      name: '经销商管理'
    },
    children: [{
      path: '/Basic/Dealer/List/list',
      name: '/Basic/Dealer/List/list',
      component: DealerList,
      meta: {
        name: '经销商管理',
        parent: '/Basic/Dealer/List'
      }
    }]
  }, {
    path: '/Basic/Credit/List',
    name: '/Basic/Credit/List',
    component: page,
    redirect: {
      name: '/Basic/Credit/List/list'
    },
    meta: {
      name: '信用管理'
    },
    children: [{
      path: '/Basic/Credit/List/list',
      name: '/Basic/Credit/List/list',
      component: CreditList,
      meta: {
        name: '信用管理',
        parent: '/Basic/Credit/List'
      }
    }]
  },
  {
    path: '/Basic/Organization/List',
    name: '/Basic/Organization/List',
    component: page,
    redirect: {
      name: '/Basic/Organization/List/list'
    },
    meta: {
      name: '销售组织'
    },
    children: [{
      path: '/Basic/Organization/List/list',
      name: '/Basic/Organization/List/list',
      component: OrganizationList,
      meta: {
        name: '销售组织',
        parent: '/Basic/Organization/List'
      }
    }]
  },
  {
    path: '/Basic/Banner/List',
    name: '/Basic/Banner/List',
    component: page,
    redirect: {
      name: '/Basic/Banner/List/list'
    },
    meta: {
      name: 'Banner管理'
    },
    children: [{
      path: '/Basic/Banner/List/list',
      name: '/Basic/Banner/List/list',
      component: BannerList,
      meta: {
        name: 'Banner管理',
        parent: '/Basic/Banner/List'
      }
    },
    {
      path: '/Basic/Banner/Add',
      name: '/Basic/Banner/Add',
      component: BannerAdd,
      meta: {
        name: '新增Banner',
        parent: '/Basic/Banner/List'
      }
    }
    ]
  },
  {
    path: '/Admins/Address/List',
    name: '/Admins/Address/List',
    component: page,
    redirect: {
      name: '/Admins/Address/List/list'
    },
    meta: {
      name: '地址管理'
    },
    children: [{
      path: '/Admins/Address/List/list',
      name: '/Admins/Address/List/list',
      component: AddressList,
      meta: {
        name: '地址管理',
        parent: '/Admins/Address/List'
      }
    }]
  },
  {
    path: '/Admins/Role/List',
    name: '/Admins/Role/List',
    component: page,
    redirect: {
      name: '/Admins/Role/List/list'
    },
    meta: {
      name: '角色管理'
    },
    children: [{
      path: '/Admins/Role/List/list',
      name: '/Admins/Role/List/list',
      component: RoleList,
      meta: {
        name: '角色管理',
        parent: '/Admins/Role/List'
      }
    }]
  }
  ],
  reports: [{
    path: '/Reports/ExportTask/List',
    name: '/Reports/ExportTask/List',
    component: page,
    redirect: {
      name: '/Reports/ExportTask/List/List'
    },
    meta: {
      name: '导出任务'
    },
    children: [{
      path: '/Reports/ExportTask/List/List',
      name: '/Reports/ExportTask/List/List',
      component: ExportTaskList,
      meta: {
        name: '导出任务',
        parent: '/Reports/ExportTask/List'
      }
    }]
  },
  {
    path: '/Reports/OrderExport/List',
    name: '/Reports/OrderExport/List',
    component: page,
    redirect: {
      name: '/Reports/OrderExport/List/List'
    },
    meta: {
      name: '订单报表'
    },
    children: [{
      path: '/Reports/OrderExport/List/List',
      name: '/Reports/OrderExport/List/List',
      component: OrderExportList,
      meta: {
        name: '订单报表',
        parent: '/Reports/OrderExport/List'
      }
    }]
  }
  ],
  goods: [{
    path: '/Goods/ProductCategory/List',
    name: '/Goods/ProductCategory/List',
    component: page,
    redirect: {
      name: '/Goods/ProductCategory/List/List'
    },
    meta: {
      name: '产品分类'
    },
    children: [{
      path: '/Goods/ProductCategory/List/List',
      name: '/Goods/ProductCategory/List/List',
      component: ProductCategoryList,
      meta: {
        name: '产品分类',
        parent: '/Goods/ProductCategory/List'
      }
    }]
  }, {
    path: '/Goods/Product/List',
    name: '/Goods/Product/List',
    component: page,
    redirect: {
      name: '/Goods/Product/List/List'
    },
    meta: {
      name: '产品管理'
    },
    children: [{
      path: '/Goods/Product/List/List',
      name: '/Goods/Product/List/List',
      component: ProductList,
      meta: {
        name: '产品管理',
        parent: '/Goods/Product/List'
      }
    }]
  }, {
    path: '/Goods/ProductUnion/List',
    name: '/Goods/ProductUnion/List',
    component: page,
    redirect: {
      name: '/Goods/ProductUnion/List/List'
    },
    meta: {
      name: '产品组合'
    },
    children: [{
      path: '/Goods/ProductUnion/List/List',
      name: '/Goods/ProductUnion/List/List',
      component: ProductUnionList,
      meta: {
        name: '产品组合',
        parent: '/Goods/ProductUnion/List'
      }
    }]
  },

  {
    path: '/Goods/SalesPrice/List',
    name: '/Goods/SalesPrice/List',
    component: page,
    redirect: {
      name: '/Goods/SalesPrice/List/List'
    },
    meta: {
      name: '价格管理'
    },
    children: [{
      path: '/Goods/SalesPrice/List/List',
      name: '/Goods/SalesPrice/List/List',
      component: SalesPriceList,
      meta: {
        name: '价格管理',
        parent: '/Goods/SalesPrice/List'
      }
    }]
  },
  {
    path: '/Goods/SalesPriceHistory/List',
    name: '/Goods/SalesPriceHistory/List',
    component: page,
    redirect: {
      name: '/Goods/SalesPriceHistory/List/List'
    },
    meta: {
      name: '历史价格'
    },
    children: [{
      path: '/Goods/SalesPriceHistory/List/List',
      name: '/Goods/SalesPriceHistory/List/List',
      component: SalesPriceHistoryList,
      meta: {
        name: '历史价格',
        parent: '/Goods/SalesPriceHistory/List'
      }
    }]
  }, {
    path: '/Promotions/Activity/List',
    name: '/Promotions/Activity/List',
    component: page,
    redirect: {
      name: '/Promotions/Activity/List/List'
    },
    meta: {
      name: '促销活动'
    },
    children: [{
      path: '/Promotions/Activity/List/List',
      name: '/Promotions/Activity/List/List',
      component: ActivityList,
      meta: {
        name: '促销活动',
        parent: '/Promotions/Activity/List'
      }
    }]
  }, {
    path: '/Goods/BomProduct/List',
    name: '/Goods/BomProduct/List',
    component: page,
    redirect: {
      name: '/Goods/BomProduct/List/List'
    },
    meta: {
      name: '促销套装'
    },
    children: [{
      path: '/Goods/BomProduct/List/List',
      name: '/Goods/BomProduct/List/List',
      component: BomProductList,
      meta: {
        name: '促销套装',
        parent: '/Goods/BomProduct/List'
      }
    }]
  }
  ],
  information: [{
    path: '/Information/Announcement/List',
    name: '/Information/Announcement/List',
    component: page,
    redirect: {
      name: '/Information/Announcement/List/List'
    },
    meta: {
      name: '通知公告'
    },
    children: [{
      path: '/Information/Announcement/List/List',
      name: '/Information/Announcement/List/List',
      component: AnnouncementList,
      meta: {
        name: '通知公告',
        parent: '/Information/Announcement/List'
      }
    }]
  },
  {
    path: '/Information/Feedback/List',
    name: '/Information/Feedback/List',
    component: page,
    redirect: {
      name: '/Information/Feedback/List/List'
    },
    meta: {
      name: '反馈信息'
    },
    children: [{
      path: '/Information/Feedback/List/List',
      name: '/Information/Feedback/List/List',
      component: FeedbackList,
      meta: {
        name: '反馈信息',
        parent: '/Information/Feedback/List'
      }
    }]
  }
  ],
  Orders: [{
    path: '/Orders/OrderRule/List',
    name: '/Orders/OrderRule/List',
    component: page,
    redirect: {
      name: '/Orders/OrderRule/List/list'
    },
    meta: {
      name: '订单规则'
    },
    children: [{
      path: '/Orders/OrderRule/List/list',
      name: '/Orders/OrderRule/List/list',
      component: OrderRuleList,
      meta: {
        name: '订单规则',
        parent: '/Orders/OrderRule/List'
      }
    }]
  },
  {
    path: '/Orders/DeliveryOrder/List',
    name: '/Orders/DeliveryOrder/List',
    component: page,
    redirect: {
      name: '/Orders/DeliveryOrder/List/list'
    },
    meta: {
      name: '出库单'
    },
    children: [{
      path: '/Orders/DeliveryOrder/List/list',
      name: '/Orders/DeliveryOrder/List/list',
      component: DeliveryOrderList,
      meta: {
        name: '出库单',
        parent: '/Orders/DeliveryOrder/List'
      }
    }]
  },
  {
    path: '/Orders/OrderMaster/List',
    name: '/Orders/OrderMaster/List',
    component: page,
    redirect: {
      name: '/Orders/OrderMaster/List/list'
    },
    meta: {
      name: '订单管理'
    },
    children: [{
      path: '/Orders/OrderMaster/List/list',
      name: '/Orders/OrderMaster/List/list',
      component: OrderList,
      meta: {
        name: '订单管理',
        parent: '/Orders/OrderMaster/List'
      }
    }]
  }, {
    path: '/Orders/OrderMaster/AuditList',
    name: '/Orders/OrderMaster/AuditList',
    component: page,
    redirect: {
      name: '/Orders/OrderMaster/AuditList/list'
    },
    meta: {
      name: '订单审核'
    },
    children: [{
      path: '/Orders/OrderMaster/AuditList/list',
      name: '/Orders/OrderMaster/AuditList/list',
      component: OrderAuditList,
      meta: {
        name: '订单审核',
        parent: '/Orders/OrderMaster/AuditList'
      }
    }]
  }
  ],
  Freight: [
    {
      path: '/Freight/List',
      name: '/Freight/List',
      component: page,
      redirect: {
        name: '/Freight/Driver/List'
      },
      meta: {
        name: '运输管理'
      },
      children: [{
        path: '/Freight/Driver/List',
        name: '/Freight/Driver/List',
        component: DriverList,
        meta: {
          name: '司机管理',
          parent: '/Freight/List'
        }
      },
      {
        path: '/Freight/Freight/List',
        name: '/Freight/Freight/List',
        component: FreightList,
        meta: {
          name: '运费项目',
          parent: '/Freight/List'
        }
      },
      {
        path: '/Freight/Freight/Record',
        name: '/Freight/Freight/Record',
        component: FreightRecordList,
        meta: {
          name: '运费结算',
          parent: '/Freight/List'
        }
      },
      ]
    },
  ]
}

const routes = [{
  path: '/',
  name: 'main',
  component: main,
  redirect: {
    name: 'index'
  },
  children: [
    ...pages.index,
    ...pages.Admins,
    ...pages.reports,
    ...pages.goods,
    ...pages.Orders,
    ...pages.information,
    ...pages.Freight
  ]
},
{
  path: '/login',
  name: 'login',
  component: login
}
]
export default new Router({
  linkActiveClass: 'is-router',
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js